import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import LegacyQuestion from 'components/LegacyQuestion';
import { v2 } from 'actions';

const { questionPreloaded } = v2.questions.actions;

const SampleQuestion = (props) => {
  const {
    questionId,
    preloadedData
  } = props;
  const [showResponseCorrectness, setShowResponseCorrectness] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const dispatch = useDispatch();
  const questions = useSelector(state => state.questions);
  const question = questions.data.entities[questionId];

  useEffect(() => {
    if (preloadedData?.data?.id && parseInt(preloadedData.data.id) === questionId) {
      dispatch(questionPreloaded(preloadedData));
    } else {
      console.warn('no preloaded data for Sample Question');
    }
  }, [preloadedData, questionId]);


  const onChangeAnswer = (newAnswer) => {
    if (!question) return;

    let nextSelectedAnswer = Array.isArray(selectedAnswer) ? [...selectedAnswer] : [];

    if (Number.isInteger(newAnswer)) {
      if (question.correct_answer_ids.length > 1) {
        const index = nextSelectedAnswer.indexOf(newAnswer);
        if (index !== -1) {
          nextSelectedAnswer.splice(index, 1);
        } else {
          nextSelectedAnswer.push(newAnswer);
        }
      } else {
        nextSelectedAnswer = [newAnswer];
      }
    } else {
      nextSelectedAnswer = newAnswer;
    }
    setSelectedAnswer(nextSelectedAnswer);
  };


  if (!question) return null;

  return (
    <div className="SampleQuestion">
      <LegacyQuestion
        question={question}
        onChangeAnswer={onChangeAnswer}
        onClickShowAnswer={() => setShowResponseCorrectness(!showResponseCorrectness)}
        showResponseCorrectness={showResponseCorrectness}
        canShowAnswer
        selectedAnswer={selectedAnswer}
      />
    </div>
  );
};

SampleQuestion.propTypes = {
  questionId: PropTypes.number.isRequired,
  preloadedData: PropTypes.object,
};

export default SampleQuestion;
